function isRecord(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function isNonEmptyString(value) {
  return typeof value === "string" && Boolean(value.trim());
}

function hasOwn(record, key) {
  return Object.prototype.hasOwnProperty.call(record, key);
}

export function publicUserId(value) {
  if (!isRecord(value)) return "";
  const candidate = value.userId ?? value.id;
  return isNonEmptyString(candidate) ? candidate.trim() : "";
}

/**
 * A public user must identify the canonical sign-in contact explicitly.
 * Google-created users are the sole null-identity shape and must already own
 * a verified, nonblank email.
 */
export function hasValidPublicUserIdentity(value) {
  if (!isRecord(value) || !publicUserId(value) || !hasOwn(value, "verificationIdentityType")) {
    return false;
  }
  if (value.verificationIdentityType === "email") {
    return isNonEmptyString(value.email);
  }
  if (value.verificationIdentityType === "phone") {
    return isNonEmptyString(value.phoneE164);
  }
  return (
    value.verificationIdentityType === null &&
    isNonEmptyString(value.email) &&
    value.emailVerified === true
  );
}
